import { xhrStatusFactory } from 'redux/reusable/xhrStatus';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import {
  clearDraft,
  fetchedNotificationSettings,
  savedDraft,
  startDraft,
  updateDraft,
} from './notificationSettings.actions';
import type { State } from './notificationSettings.types';
import { withXhrStatusReducer } from './notificationSettings.types';

const initialState: State = {
  settings: null,
  draft: null,
  xhrStatus: xhrStatusFactory(),
};

const reducer = reducerWithInitialState<State>(initialState)
  .casesWithAction([fetchedNotificationSettings, savedDraft], (state, action) => ({
    ...state,
    settings: action.payload,
  }))
  .caseWithAction(startDraft, state => {
    if (!state.settings) return state;

    return {
      ...state,
      draft: { ...state.settings },
    };
  })
  .caseWithAction(clearDraft, state => {
    if (!state.draft) return state;

    return {
      ...state,
      draft: null,
    };
  })
  .caseWithAction(updateDraft, (state, action) => {
    if (!state.draft) return state;

    const updatedNotificationSettings = action.payload.notification_settings
      ? {
          ...state.draft.notification_settings,
          ...action.payload.notification_settings,
        }
      : state.draft.notification_settings;

    const updatedReminders = action.payload.reminders
      ? {
          ...state.draft.reminders,
          ...action.payload.reminders,
        }
      : state.draft.reminders;

    return {
      ...state,
      draft: {
        notification_settings: updatedNotificationSettings,
        reminders: updatedReminders,
      },
    };
  });

export default withXhrStatusReducer(reducer);
